// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".create-complete[data-v-6f46b27e]{text-align:center;padding:50px 0}.create-complete .complete-title[data-v-6f46b27e]{font-size:18px;font-weight:500;color:#0bc15c;margin-bottom:30px}.create-complete .complete-subtitle[data-v-6f46b27e]{color:#273142;margin-bottom:50px}.create-complete .complete-subtitle span[data-v-6f46b27e]{color:#f27a1a;border-bottom:1px solid #f27a1a}", ""]);
// Exports
module.exports = exports;
